import { render, staticRenderFns } from "./BannersDestaque.vue?vue&type=template&id=f0128a24&scoped=true"
import script from "./BannersDestaque.vue?vue&type=script&lang=js"
export * from "./BannersDestaque.vue?vue&type=script&lang=js"
import style0 from "./BannersDestaque.vue?vue&type=style&index=0&id=f0128a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0128a24",
  null
  
)

export default component.exports